// Custom Formkit helper to change the password field type and icon on suffix click
import type { FormKitNode } from '@formkit/core';

export function useCustomFormkitHelper() {
    const togglePasswordField = (node: FormKitNode) => {
        node.props.suffixIcon = node.props.suffixIcon === 'eye' ? 'eye-strike-through' : 'eye';
        node.props.type = node.props.type === 'password' ? 'text' : 'password';
    };

    return {
        togglePasswordField,
    };
}
